import { AREA_INTEREST_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';
import { Filter } from '@cubejs-client/core';

const AREA_OF_INTEREST_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.area_interest`],
  limit: undefined,
});

const areaOfInterestFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.areaOfInterestLabel',
  sourceCube: AREA_INTEREST_CUBE_NAME,
  defaultValue: [],
  type: 'multiselect',
  placeholder: 'global.filters.formControls.areaOfInterestPlaceholder',
  searchable: true,
  clearable: true,
  getOptionsQuery: AREA_OF_INTEREST_OPTIONS,
  mapResult: result => {
    const key = `${AREA_INTEREST_CUBE_NAME}.area_interest`;
    const value = toStringOrNull(result[key]);
    if (value === null) return null;
    return {
      value,
      label: value,
    };
  },
  applyFilter: (value): Filter | undefined => {
    if (Array.isArray(value) && value.every(filterValue => typeof filterValue === 'string')) {
      return {
        member: `${AREA_INTEREST_CUBE_NAME}.area_interest`,
        operator: 'equals',
        values: value,
      };
    }
  },
};

export default areaOfInterestFilter;
